<script>
import Layout from '@layouts/primary'
// import { RRule, RRuleSet, rrulestr } from 'rrule'
import { onlineInvoiceMethods } from '@state/helpers'

export default {
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'Invoices',
    meta: [{ name: 'invoices', content: 'Invoices' }],
  },
  components: { Layout },
  data() {
    return {
      search: '',
      headers: [
        { text: 'Invoice Number', value: 'invoice_number' },
        { text: 'Date', value: 'date' },
        { text: 'Status', value: 'status' },
        { text: 'View Invoice', value: 'date' },
      ],
      invoices: [],

    }
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
    this.getInvoices().then(response => {
      let obj = this.$store.state.onlineInvoices.objects
      for (var v in obj) {
        this.invoices.push(obj[v])
      }
      // console.log(obj)
    })
  },
  methods: {
    ...onlineInvoiceMethods,
    submit() {
      this.$validator.validateAll()

    },
    clear() {

    },
    changeRoute(r) {
      this.$router.push(r)
    },
  },
}
</script>

<template>
  <Layout>
    <VContainer>
      <h2 :class="$style.routeHeader">
        Invoices
      </h2>

      <VLayout style="width: 100%">

        <VFlex
          xs0
          sm12
        />
        <VFlex
          xs12
          md5
        >
          <VTextField
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          />
        </VFlex>
      </VLayout>

      <VDataTable
        class
        :headers="headers"
        :items="invoices"
        :search="search"
      >
        <template
          slot="items"
          slot-scope="props"
        >

          <td class="text-xs-left">
            {{ props.item.invoice_number }}
          </td>
          <td class="text-xs-left">
            {{ props.item.date }}
          </td>
          <td class="text-xs-left">
            {{ props.item.status }}
          </td>

          <td class="justify-center px-0">
            <VBtn

              slot="activator"
              style="position:relative; margin: 0 auto"
              color="blue"
              :href="props.item.url"
              target="_blank"
            >
              View Invoice
            </VBtn>
          </td>
        </template>
        <VAlert
          slot="no-results"
          :value="true"
          color="error"
          icon="warning"
        >
          Your search for "{{ search }}" found no results.
        </VAlert>
      </VDataTable>
    </VContainer>

  </Layout>
</template>

<style lang="scss" module>
    @import '@design';

    .routeHeader {
        display: inline-block;
    }

    .addButton {
        display: inline-block;
        float: right;
    }
</style>
